"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InputArgs = (function () {
    function InputArgs(type, title, description) {
        this.type = type;
        this.title = title;
        this.description = description;
    }
    InputArgs.isValid = function (args) {
        return true;
    };
    InputArgs.parseArgs = function (params, thow) {
        if (thow === void 0) { thow = true; }
        if (this.isValid(params)) {
            return params;
        }
        throw new Error("Invalid options passed to @Input()");
    };
    InputArgs.prototype.isValid = function () {
        return InputArgs.isValid(this);
    };
    return InputArgs;
}());
exports.default = InputArgs;
//# sourceMappingURL=InputArgs.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/decorator-form/dist/decorators/input/InputArgs.js
// module id = 1459
// module chunks = 0